import React from 'react';
import { Link } from 'react-router-dom';
import { Notification } from '../../types';
import styles from './Notifications.module.css';
import { formatDistanceToNow } from 'date-fns';
import { ar } from 'date-fns/locale/ar';

interface NotificationsDropdownProps {
  notifications: Notification[];
  onMarkAsRead: (id: number) => void;
  onMarkAllAsRead: () => void;
}

const NotificationsDropdown: React.FC<NotificationsDropdownProps> = ({
  notifications,
  onMarkAsRead,
  onMarkAllAsRead,
}) => {
     const uniqueNotifications = Array.from(
    new Map(notifications.map(notif => [notif.id, notif])).values()
  );
  return (
    <div className={styles.dropdownContainer}>
      <div className={styles.dropdownHeader}>
        <h3>الإشعارات</h3>
        <button onClick={onMarkAllAsRead} className={styles.markAllButton}>
          تحديد الكل كمقروء
        </button>
      </div>
      <div className={styles.dropdownList}>
        {uniqueNotifications.length === 0 ? (
          <p className={styles.noNotifications}>لا توجد إشعارات جديدة.</p>
        ) : (
          // !! نستخدم المصفوفة المنقاة هنا
          uniqueNotifications.map((notif) => (
            <div
              key={notif.id} // الـ key هنا ستكون فريدة دائماً
              className={`${styles.dropdownItem} ${notif.status === 'unread' ? styles.unread : ''}`}
              onClick={() => onMarkAsRead(notif.id)}
            >
              <p className={styles.itemTitle}>{notif.title}</p>
              <p className={styles.itemMessage}>{notif.message}</p>
              <span className={styles.itemDate}>
                {/* ... (عرض التاريخ) ... */}
              </span>
            </div>
          ))
        )}
        {notifications.length === 0 ? (
          <p className={styles.noNotifications}>لا توجد إشعارات جديدة.</p>
        ) : (
          notifications.map((notif) => (
            <div
              key={notif.id}
              className={`${styles.dropdownItem} ${notif.status === 'unread' ? styles.unread : ''}`}
              onClick={() => onMarkAsRead(notif.id)}
            >
              <p className={styles.itemTitle}>{notif.title}</p>
              <p className={styles.itemMessage}>{notif.message}</p>
              <span className={styles.itemDate}>
                {formatDistanceToNow(new Date(notif.created_at), { addSuffix: true, locale: ar })}
              </span>
            </div>
          ))
        )}
      </div>
      <div className={styles.dropdownFooter}>
        <Link to="/notifications">عرض كل الإشعارات</Link>
      </div>
    </div>
  );
};

export default NotificationsDropdown;
